export default __webpack_public_path__ + "static/media/figuremap30.6d363bf2.png";